import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const CvDocument = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M1 1C1 0.447715 1.44772 0 2 0H20C20.5523 0 21 0.447715 21 1V23C21 23.5523 20.5523 24 20 24H2C1.44772 24 1 23.5523 1 23V1ZM3 2V22H19V2H3Z", fill: "#2C2C2A" }),
    React.createElement("path", { d: "M11 11H5V9H11V11Z", fill: "#2C2C2A" }),
    React.createElement("path", { d: "M11 7H5V5H11V7Z", fill: "#2C2C2A" })), 'CvDocument', { width: 24, height: 24, viewBox: '0 0 24 24' });
export default CvDocument;
